module.exports = __webpack_public_path__ + "img/alex_carita_01.b3591843.svg";